var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav-profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Profile",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.25 25.8229V25.404C26.25 22.9755 23.895 21 21 21H12C9.105 21 6.75 22.9755 6.75 25.404V25.8229C4.4295 23.3974 3 20.1135 3 16.5C3 9.05625 9.05587 3 16.5 3C23.9441 3 30 9.05625 30 16.5C30 20.1135 28.5701 23.3974 26.25 25.8229ZM24.75 27.1747C22.4666 28.9436 19.605 30 16.5 30C13.395 30 10.5334 28.9436 8.25 27.1747V25.404C8.25 23.8027 9.93225 22.5 12 22.5H21C23.0677 22.5 24.75 23.8027 24.75 25.404V27.1747ZM16.5 1.5C8.229 1.5 1.5 8.229 1.5 16.5C1.5 24.771 8.229 31.5 16.5 31.5C24.771 31.5 31.5 24.771 31.5 16.5C31.5 8.229 24.771 1.5 16.5 1.5ZM16.5 16.3126C14.4323 16.3126 12.75 14.6303 12.75 12.5626C12.75 10.4948 14.4323 8.81257 16.5 8.81257C18.5677 8.81257 20.25 10.4948 20.25 12.5626C20.25 14.6303 18.5677 16.3126 16.5 16.3126ZM16.5 7.31258C13.605 7.31258 11.25 9.66758 11.25 12.5626C11.25 15.4576 13.605 17.8126 16.5 17.8126C19.395 17.8126 21.75 15.4576 21.75 12.5626C21.75 9.66758 19.395 7.31258 16.5 7.31258Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profile.e2e487e454f0bd1acf87a52b1f159436.svg";